import { Box, CircularProgress } from "@mui/material";

const Spinner = ({ height = 100, width = "100%" }) => <Box
    sx={{
        width, display: "flex", height: height, alignItems: "center", justifyContent: "center"
    }}
>
    <CircularProgress color="primary" />
</Box>

export default Spinner